import React, { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ErrorBoundaryComponent = ({ children }) => {
  const [hasError, setHasError] = useState(false);
  const navigate = useNavigate();  

  // Aquí manejamos el error usando el hook useEffect
  useEffect(() => {
    const errorHandler = (error, info) => {
      console.error("ErrorBoundary atrapó un error:", error, info);
      setHasError(true);
    };

    // Registramos un manejador global de errores
    window.onerror = errorHandler;
    return () => {
      // Limpiamos el manejador de errores cuando el componente se desmonte
      window.onerror = null;
    };
  }, []);

  if (hasError) {
    return (
      <Box textAlign="center" mt={5} p={3}>
        <Typography variant="h1" color="error" gutterBottom>
          Error
        </Typography>
        <Typography variant="h5" color="text.secondary" gutterBottom>
          Algo salió mal.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/")}
        >
          Volver al Inicio
        </Button>
      </Box>
    );
  }

  return children;  // Si no hay error, renderiza los hijos normalmente
};

export default ErrorBoundaryComponent;
